"use client"

import { useHudContext } from "../../hud/shared/playbookHUDInfra"
import { type PowerRegionData } from "../powerBubbleChartData"
import {
  getHoveredRegionId,
  type HoveredPowerItem,
} from "../hoveredPowerItem"
import { getLargestComputeShown } from "./powerTooltipData"
import { TooltipHeader } from "./DoPTooltipHeader"
import { RegionGroup } from "./DoPRegionGroup"

// Tooltip body for the distribution-of-power HUD variants: a header plus one
// group per region (its labs nested underneath), with the row matching whatever
// flag or lab the user hovers in the chart highlighted. Pass hoveredItem={null}
// for the un-highlighted resting state.
export const DistributionOfPowerTooltipContent = ({
  regions,
  hoveredItem,
}: {
  regions: PowerRegionData[]
  hoveredItem: HoveredPowerItem | null
}) => {
  const { year } = useHudContext()
  const hoveredRegionId = getHoveredRegionId(hoveredItem, regions)
  const largestComputeShown = getLargestComputeShown(regions)
  return (
    <div className="font-sans text-[11px] px-2 pb-1 pt-2 leading-tight">
      <TooltipHeader year={year} unitHeader="H100 equivalents" />
      {regions.map(region => (
        <RegionGroup
          key={region.id}
          region={region}
          hoveredItem={hoveredItem}
          hoveredRegionId={hoveredRegionId}
          hasHover={hoveredItem !== null}
          largestComputeShown={largestComputeShown}
        />
      ))}
    </div>
  )
}
